export const renameLLMProvider = (provider) => {
    if (provider === 'AZURE_OPENAI') {
        return 'Azure OpenAI';
    }
    if (provider === 'SNOWFLAKE_MISTRAL') {
        return 'Snowflake Mistral';
    }
    if (provider === 'GOOGLE_GEMINI') {
        return 'Google Gemini';
    }
    return provider;
};
//# sourceMappingURL=setting-content.util.js.map